/*******************************************************************************
* @ngdoc   service
* @module  books.ui.storeAccountManagement
* @name    books.ui.storeAccountManagement.service:storeAccountManagement
*
* @description 
* Service object for communicating with the storeAccountManagementController on 
* the server.
*******************************************************************************/
/* @ngInject */ export function StoreAccountManagementProvider() {
  'use strict';
  this.httpServiceBase = '/books/storeAccountAdmin/';

  this.httpServices = (http) => ({
    getEntityList: () => http.get('getEntityList'),
    getStoreLogins: () => http.get('getStoreLogins'),
    registerForStore: (entity) => http.post('registerForStore', entity),
    resetStorePassword: (entityID) =>
      http.get(`resetStorePassword/${entityID}`)
  });

  this.$get = ['HTTPService', function (HTTPService) {
    return HTTPService.make(this.httpServiceBase, this.httpServices);
  }];
};
